<!-- 直播 -->
<template>
  <div :class="['live-page', isFullScreen ? 'is-full-screen' : '']">
    <!-- 播放器盒子 -->
    <div class="live-box">
      <filePlayer
        :initData="initData"
        v-if="initCC"
        :buyInfo="buyInfo"
        @changeScreenStatus="changeScreenStatus"
        @changeChatNoticeStatus="changeChatNoticeStatus"
        @isShowTeacher="isShowTeacher"
        ref="player"
      />
      <NotStart
        ref="notStart"
        :isFullScreen="isFullScreen"
        :startTime="liveInfo.startTime"
        :placeImg="liveInfo.notStartPlaceholderImg"
      />
    </div>

    <!--聊天，课程推荐，公告,广告 -->
    <!-- <div class="live-content"  v-if="initCC" v-show="!isFullScreen"> -->
    <div
      :class="[
        'live-content',
        isFullScreen && showTeacher ? 'full-live-content' : '',
        isAndroid && isFullScreen ? 'android-live-content' : '',
      ]"
      v-if="initCC"
      v-show="chatNoticeStatus"
    >
      <div class="teacherList" v-if="isFullScreen && showTeacher">
        <span v-for="(item, index) in RecommendCourse.teacherList" :key="index">
          {{ item.name }}{{ index != RecommendCourse.teacherList.length - 1 ? '、' : '' }}
        </span>
      </div>
      <div class="live-content-box">
        <ul class="live-content-tab">
          <li
            @click="changeTab(index)"
            v-for="(item, index) in tablist"
            :key="index"
            v-show="isFullScreen ? index <= 1 : index >= 0"
          >
            {{ cardSelected !== 0 && index === 0 ? '老师' : item }}
            <img
              v-if="index === 0"
              @click="openTabCard()"
              class="icon"
              :src="showTabCard ? UPICON : DOWNICON"
              alt=""
            />
            <span v-if="selected === index" class="border"></span>
          </li>
          <li v-show="!isFullScreen">
            <JoinGroup v-if="buyInfo.productId" :buyInfo="{ ...buyInfo }" />
          </li>
        </ul>
        <ul class="tab-card" v-show="showTabCard">
          <li
            v-for="(item, index) in tabCardList"
            :key="index"
            :class="{ active: cardSelected === index }"
            @click="changeList(index)"
          >
            <span>{{ item }}</span>
            <img v-show="cardSelected === index" class="icon" :src="CHECKEDICON" alt="" />
          </li>
        </ul>
        <div
          :class="[
            'tab-content',
            !isFullScreen && RecommendCourse.imagesH5 ? 'tab-content-padding' : '',
          ]"
        >
          <Advertising v-if="!isFullScreen" :RecommendCourse="RecommendCourse" :filePlayer="true" />
          <Chat
            :skuId="buyInfo.skuId"
            :isCommentGroup="isCommentGroup"
            v-show="selected === 0"
            :selected="cardSelected"
            :disable="isFullScreen"
            :recommendIconShow="recommendIconShow"
            @openRecommend="(recommendPopup = true), (idx = -1)"
          />
          <Announcement v-show="selected === 1" :isFullScreen="isFullScreen" />
        </div>
      </div>
    </div>
    <commonLoading v-if="!initCC" />
    <div
      v-if="isFullScreen && liveCouponList.length"
      @click="showModal(1)"
      class="fullRecommendIconCoupon"
    >
      <img class="recommendIcon" src="../../assets/img/live/recommendIcon1.gif" alt="" />
    </div>
    <div
      v-if="isFullScreen && RecommendCourse.courseVOList"
      @click="showModal(0)"
      class="fullRecommendIcon"
    >
      <img class="recommendIcon" src="../../assets/img/live/recommendIcon.gif" alt="" />
    </div>

    <Recommends
      v-show="recommendPopup"
      :recommendPopup="recommendPopup"
      @closeRecommend="recommendPopup = false"
      :isFullScreen="isFullScreen"
      @sendCouponList="sendCouponList"
      :idx="idx"
    />
    <RecommendPolling
      :isAlertRecommend="isAlertRecommend"
      :isFullScreen="isFullScreen"
      :liveCouponList="liveCouponList"
      @showPopupCoupon="showPopupCoupon"
    />
    <OpenApp v-if="!isFullScreen" />
    <Foot v-if="!isFullScreen" />
    <!-- <AgreementPop :openCourseId="buyInfo.id"/> -->
    <EntranceTest v-if="buyInfo.id" :id="buyInfo.id" />
    <PopupCoupon ref="popupCoupon" :popupCouponInfo="popupCouponInfo" @openCoupon="openCoupon" />
  </div>
</template>

<script>
import loadJS from 'load-js';
import { mapState } from 'vuex';
// eslint-disable-next-line import/extensions
import filePlayer from '@/pages/live/components/filePlayer';
// eslint-disable-next-line import/extensions
import commonLoading from '@/components/commonComponents/CommonLoading';
import Foot from '@/components/foot/privacy.vue';
import { reqIsBuyProduct } from '../../api/courseDetail/index';
import { LIVE_SITE_ID } from '../../utils/common';
import Chat from './components/chat.vue';
import Announcement from './components/announcement.vue';
import Advertising from './components/advertising.vue';
import OpenApp from './components/openApp.vue';
import { liveRecommends, liveBroadcast } from '../../api/live/index';
// import AgreementPop from './components/agreementPop.vue';
import EntranceTest from './components/entranceTest.vue';
import Recommends from './components/recommends.vue';
import JoinGroup from './components/joinGroup.vue';
import RecommendPolling from './components/recommendPolling.vue';
import PopupCoupon from './components/popupCoupon.vue';
import NotStart from './components/notStart.vue';
import { replaceHyphens } from '@/utils/tools';

export default {
  data() {
    return {
      tablist: ['讨论区', '公告'],
      tabCardList: ['全部讨论', '仅看老师'],
      courseId: this.$route.query.courseId,
      roomId: this.$route.query.roomId,
      buyInfo: {}, // 开课信息
      initData: {},
      initCC: false, // 判断加载直播组件的时间
      RecommendCourse: {}, // 推荐数据
      DOWNICON: require('../../assets/img/live/down.png'),
      UPICON: require('../../assets/img/live/up.png'),
      CHECKEDICON: require('../../assets/img/live/checked.png'),
      selected: 0,
      cardSelected: 0,
      showTabCard: false,
      firstTab: false,
      isFullScreen: false, // 是否全屏
      chatNoticeStatus: true, // 全屏时聊天框与公告的显隐
      recommendStatus: false, // 全屏时推荐课程的显隐
      showTeacher: false, // true 展示教师名
      isAndroid: navigator.userAgent.match(/android/i), // 处理在安卓机上的兼容问题(全屏时可点击 但不显示)
      recommendPopup: false,
      recommendIconShow: false, // 购物袋显隐
      isAlertRecommend: 0, // 是否允许轮询
      isCommentGroup: 0, // 直播间是否开启分组
      liveCouponList: [],
      popupCouponInfo: {},
      idx: 0,
      liveInfo: {},
    };
  },
  components: {
    filePlayer,
    Chat,
    Advertising,
    Announcement,
    commonLoading,
    OpenApp,
    Foot,
    // AgreementPop,
    EntranceTest,
    Recommends,
    JoinGroup,
    RecommendPolling,
    PopupCoupon,
    NotStart,
  },
  watch: {},
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.initCC = false;
    loadJS([
      {
        async: false,
        url: 'https://view.csslcloud.net/js/sdk/3.7.0/liveSDK.js',
      },
    ]).then(() => {
      this.getBuyInfo();
    });
    window.sessionStorage.removeItem('receiveCouponId');
  },

  destroyed() {},
  methods: {
    // 初始化播放器
    async initLive() {
      const res = await liveBroadcast(this.$route.query.liveId);
      const { isCommentGroup = 0 } = res.data;
      this.isCommentGroup = isCommentGroup;
      this.liveInfo = res.data;
      const userid = LIVE_SITE_ID;
      // eslint-disable-next-line no-undef
      this.initData = {
        userid, // cc用户id
        roomid: this.roomId, // 直播间id
        viewercustomua: this.userInfo.id, // 用户id
        viewername: this.userInfo.nickName, // 用户名
        viewertoken: `${this.userInfo.id}:${this.buyInfo.id}`,
        pcH5Live: true,
        groupid: this.buyInfo.skuId,
      };
      this.initCC = true;
    },
    // 查询开课信息(是否购买)
    async getBuyInfo() {
      const res = await reqIsBuyProduct(this.courseId);
      if (res?.code === 0 && res?.data?.length) {
        // 已购买
        this.buyInfo = res?.data?.[0];
        this.initLive();
        this.getCourseIds();
      } else {
        // 未购买
        this.jumpCourseDetail();
      }
    },
    changeScreenStatus() {
      // 更改屏幕全屏状态
      if (this.isFullScreen) {
        this.isFullScreen = false;
        this.$nextTick(() => {
          const winW = window.innerWidth;
          const winH = window.innerHeight;
          const ele = document.getElementsByClassName('live-page')[0];
          ele.style.width = `${winW}px`;
          ele.style.height = `${winH}px`;
          ele.style.transform = 'rotate(0)';
          ele.style.transformOrigin = 'bottom left';
        });
      } else {
        this.isFullScreen = true;
        this.selected = 0;
        this.$nextTick(() => {
          const winH = window.innerHeight;
          const winW = window.innerWidth;
          const ele = document.getElementsByClassName('is-full-screen')[0];
          ele.style.width = `${winH}px`;
          ele.style.height = `${winW}px`;
          ele.style.transform = `rotate(90deg) translateX(-${winW}px)`;
          ele.style.transformOrigin = 'bottom left';
        });
      }
    },
    noUpOrDown(e) {
      e.preventDefault();
    },
    changeChatNoticeStatus() {
      // 全屏时 聊天框与公告的显示与隐藏
      this.chatNoticeStatus = !this.chatNoticeStatus;
    },
    recommendShow() {
      // 显示推荐课程
      this.recommendStatus = !this.recommendStatus;
    },
    isShowTeacher(status) {
      // 获取当前直播状态
      this.showTeacher = status;
    },
    // 未购买跳转到详情页
    jumpCourseDetail() {
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: this.courseId,
        },
      });
    },
    async getCourseIds() {
      const res = await liveRecommends({ liveId: this.$route.query.liveId });
      if (res?.code === 0) {
        this.RecommendCourse = res?.data;
        let { couponVOList, courseVOList } = this.RecommendCourse;
        this.isAlertRecommend = this.RecommendCourse.isAlertRecommend;
        couponVOList = couponVOList ?? [];
        courseVOList = courseVOList ?? [];
        this.liveCouponList = couponVOList;
        if (couponVOList.length || courseVOList.length) {
          this.recommendIconShow = true;
        }
      }
    },
    openTabCard() {
      // this.showTabCard = !this.showTabCard;
    },
    hideCard() {
      this.showTabCard = false;
    },
    changeList(index) {
      this.cardSelected = index;
      this.showTabCard = false;
    },
    changeTab(index) {
      if (this.selected === index && index === 0) {
        this.showTabCard = !this.showTabCard;
        return;
      }
      this.selected = index;
      if (index > 0) {
        this.showTabCard = false;
      }
    },
    sendCouponList(data) {
      if (!data?.length) return;
      this.liveCouponList = data;
    },
    showPopupCoupon(data) {
      this.popupCouponInfo = data;
      this.$refs.popupCoupon.show = true;
    },
    showModal(idx) {
      this.recommendPopup = true;
      this.idx = idx;
    },
    openCoupon() {
      this.recommendPopup = true;
      this.idx = 1;
    },
    checkLiveStatus(liveStatus) {
      if (liveStatus) {
        this.$refs.notStart.hide();
        return;
      }
      const { notStartPlaceholderImg, startTime } = this.liveInfo;
      const currentTime = new Date().getTime();
      if (new Date(replaceHyphens(startTime)).getTime() > currentTime) {
        console.log('直播开始时间未到');
        this.$refs.notStart.showCount();
      } else {
        console.log('已到了开始直播的时候', liveStatus);
        if (!liveStatus && notStartPlaceholderImg) {
          this.$refs.notStart.showImg();
        }
      }
    },
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    try {
      this.$refs.player.stopLive('stop');
    } catch (error) {
      next();
    }
    next();
  },
};
</script>
<style scoped lang="scss">
::v-deep .common-foot {
  position: fixed;
}
.live-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;

  .live-box {
    position: relative;
    width: 100%;
    height: calc(100vw * 0.5625);
    background: black;
  }

  .live-content {
    position: relative;
    flex: 1;
    width: 100%;
    overflow: auto;
    .live-content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;
      .live-content-tab {
        display: flex;
        align-items: center;
        width: 100%;
        height: 120px;
        background: #fff;
        li {
          position: relative;
          width: 33%;
          color: #333;
          font-size: 32px;
          text-align: center;
          .border {
            position: absolute;
            right: 0;
            bottom: -20px;
            left: 0;
            display: block;
            width: 50px;
            height: 6px;
            margin: 0 auto;
            background: #ff6c02;
            border-radius: 10px 10px 0 0;
          }
        }
        li:first-child {
          color: #ff6c02;
          border-right: 1px solid #eee;
        }
        li:last-child {
          margin-left: auto;
        }
      }
    }
  }
}
.tab-content {
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  overflow: auto;
}
.tab-content-padding {
  padding-top: 170px;
}
::v-deep .van-tabs {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}
::v-deep .van-tab {
  // border-right: 1px solid #eee;
}
::v-deep .van-tabs__wrap {
  width: 100%;
  height: 52px;
}
::v-deep .van-tabs__content {
  flex: 1;
  width: 100%;
  overflow: auto;
}
::v-deep .van-tabs__line {
  width: 25px;
  background-color: #ff6c02;
  border-radius: 10px 10px 0 0;
}
::v-deep .van-tab__text--ellipsis {
  font-size: 15px;
}
.icon {
  position: relative;
  top: 6px;
  width: 32px;
  height: 32px;
}
.tab-card {
  position: absolute;
  top: 104px;
  left: 0;
  z-index: 11;
  width: 100%;
  height: 208px;
  background: #fff8f2;
  li {
    padding: 40px 0 0 40px;
    color: #333;
    font-size: 28px;
  }
  li.active {
    color: #ff6c02;
    font-size: 28px;
  }
}
.is-full-screen {
  .live-box {
    height: 100vw;
  }

  .live-content {
    position: absolute;
    top: calc(100vw * 0.27);
    right: 0;
    width: 25%;
    height: calc(100vw * 0.73);
    overflow: hidden;
    background: #fafafa;
    .teacherList {
      width: 100%;
      height: 10%;
      padding: 25px 30px 0;
      overflow: hidden;
      font-size: 25px;
      white-space: nowrap;
      text-overflow: ellipsis;
      background: #fff;
    }
    .live-content-box {
      position: relative;
      .live-content-tab {
        height: unset;
        padding: 20px 10px;
        background: #fff;
        li {
          width: 50%;
        }
        li:nth-child(2) {
          border-right: none;
        }
      }
      .tab-card {
        top: 78px;
        height: 150px;
        li {
          padding: 20px;
        }
      }
    }
  }
  .android-live-content {
    position: fixed;
    .live-content-box {
      .tab-card {
        position: fixed;
        top: 37.5%;
        right: 0;
        left: initial;
        width: 25%;
      }
    }
  }
  .full-live-content {
    top: 0;
    right: 0;
    height: 100vw;
  }
  .full-live-content.android-live-content {
    .live-content-box {
      .tab-card {
        position: fixed;
        top: 20.5%;
        right: 0;
        left: initial;
        width: 25%;
      }
    }
  }
  .fullRecommendIcon {
    position: fixed;
    top: 50%;
    left: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    // background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .fullRecommendIconCoupon {
    position: fixed;
    top: 35%;
    left: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    img {
      width: 70px;
      height: 70px;
    }
  }
  .fullRecoment {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 11;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    .recomentContent {
      position: absolute;
      top: 0;
      right: 0;
      width: 50%;
      height: 100%;
      overflow: auto;
      background: rgba(0, 0, 0, 0.3);
      .title {
        margin-top: 40px;
        padding-left: 40px;
        color: #fff;
        font-size: 40px;
      }
    }
  }
}
</style>
